import React, {useEffect, useMemo, useState} from "react";
import PropTypes from 'prop-types'
import TreeItem from "@material-ui/lab/TreeItem";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {getParamsFromString} from "../../../JsonScreen/Utils";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../JsonScreen/Utils/lib";
import {generateBorder} from "../../../JsonScreen/Utils/generateStyles";
import IconCustom from "../../../../Utils/IconCustom/IconCustom";
import useWebSocket from "../../../../Hooks/useWebSocket";
import clsx from "clsx";
import {executeBool} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {Tooltip} from "@material-ui/core";

const useTreeItemStyles = makeStyles((theme) => ({
    disabledItem: {
         opacity: 0.5,
    },
    // "@global": {
    //     ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover, .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label": {
    //         backgroundColor: "transparent"
    //     }
    // },
    root: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
    rootDisabled: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: 'transparent',
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `transparent`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
    content: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: 15,
        fontWeight: theme.typography.fontWeightMedium,
        '$expanded > &': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        paddingLeft: props => props.level * 7
    },
    group: {
        marginLeft: 0,
        //paddingLeft: 10,
        '& $content': {
            //paddingLeft: props => props.level * 20,
        },
    },
    expanded: {},
    selected: {},
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
        backgroundColor: "transparent !important",
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
    },
    labelIcon: {
        marginRight: theme.spacing(1),
    },
    labelText: {
        fontWeight: 'normal',
        flexGrow: 1,
    },
}));

function StyledTreeItem(props) {
    const {
        labelText, labelIcon, labelInfo, iconType, subRef,
        badge, color, bgColor, level, styles: sourceStyles,
        screenName, events, doActions, menuStyles, disabledCondition, actionContext, closedCompact, isOpenDrawer,
        ...other
    } = props;
    const styles = sourceStyles ? sourceStyles[0] || {} : {};
    const containerStyles = sourceStyles ? sourceStyles[1] || {} : {};
    const borderContainer = generateBorder(containerStyles);
    const hoverStyles = styles.hoverStyles ? {
        color: styles.hoverStyles.color,
        background: styles.hoverStyles.background
    } : {};
    useWebSocket(events, doActions);
    const isCompact = closedCompact && !isOpenDrawer;
    const classes = useTreeItemStyles({level: isCompact ? 0 : props.level, hoverStyles});
    const [badgeValue, setBadgeValue] = useState('0')
    const {globalValues} = useSelector(state => state.jsonScreen);
    const {userLanguage} = useSelector(state => state.app);
    const badgeExecuted = badge ? getParamsFromString(badge, globalValues, screenName) : null;
    const isDisabled = useMemo(() => {
        if (disabledCondition) {
            return executeBool({...globalValues, ...actionContext}, disabledCondition, screenName)
        }
        return false;
    }, [JSON.stringify(globalValues), disabledCondition, JSON.stringify(actionContext)])

    useEffect(() => {
        badgeExecuted && setBadgeValue(badgeExecuted);
    }, [badgeExecuted])
    return (
        <TreeItem
            className={clsx(menuStyles.className)}
            label={
                <div className={clsx(classes.labelRoot, 'sb-menu-item', {[classes.disabledItem]: (isDisabled || subRef)})} style={{padding: styles.padding}}>
                    <Tooltip title={isCompact ? multiLanguageValue(labelText, userLanguage) : ""}>
                        <IconCustom iconType={iconType}
                                    className={clsx(classes.labelIcon, 'sb-menu-item-icon')}
                                    style={{color: styles.color ? styles.color : "inherit"}}>
                            {labelIcon}
                        </IconCustom>
                    </Tooltip>
                    {/*remove text when sidebar is compact*/}
                    {isCompact ? <></> :
                        <Typography variant="body2" className={clsx(classes.labelText, 'sb-menu-item-label')}
                                    style={{color: styles.color ? styles.color : "inherit"}}
                        >
                            {multiLanguageValue(labelText, userLanguage)}
                        </Typography>}

                    <Typography variant="caption" color="inherit"
                                style={{color: styles.color ? styles.color : "inherit", fontWeight: 'bold'}}
                    >
                        {badge ? badgeValue === '0' ? '' : badgeValue : ''}
                    </Typography>
                </div>
            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': hoverStyles.background ? hoverStyles.background : styles.background ? styles.background : bgColor,
                padding: containerStyles.padding,
                ...borderContainer,
                borderColor: containerStyles.borderColor,
            }}
            classes={{
                root: clsx(classes.root, {[classes.rootDisabled]: isDisabled}),
                content: classes.content,
                expanded: classes.expanded,
                selected: classes.selected,
                group: classes.group,
                label: classes.label,
            }}
            {...other}
        />
    );
}

export default StyledTreeItem
StyledTreeItem.defaultProps = {
    menuStyles: {}
}
StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType,
    iconType: PropTypes.string,
    labelInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    labelText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    level: PropTypes.number,
    events: PropTypes.array,
    menuStyles: PropTypes.object,
};
